import { render, staticRenderFns } from "./categories-button.component.vue?vue&type=template&id=37876bd4&scoped=true"
import script from "./categories-button.component.vue?vue&type=script&lang=js"
export * from "./categories-button.component.vue?vue&type=script&lang=js"
import style0 from "./categories-button.component.vue?vue&type=style&index=0&id=37876bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37876bd4",
  null
  
)

export default component.exports